import React from 'react';
import styled from 'styled-components';

const NavBarItem = ({ title, active, IconComponent = React.Fragment }) => (
  <div className={`dropdown-item pointer${active ? ' active' : ''}`}>
    <IconComponent className="icon" active={active} />
    <span>{title}</span>
  </div>
);

const HoverIcon = styled.svg`
  --color: ${({ active }) =>
    active ? 'var(--active-color)' : 'var(--inactive-color)'};
`;

const NavBar = ({ user }) => (
  <nav className="navbar navbar-expand-lg py-3 py-lg-0 bg-white">
    <img
      className="navbar-brand logo d-block d-lg-none"
      src="/images/logo.png"
      alt="Primary logo"
    />
    <div className="dropdown w-lg-100">
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="dropdown"
        data-bs-target="#navbarItems"
        aria-controls="navbarItems"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i className="fa-solid fa-bars h5 mb-0 d-md-block"></i>
      </button>
      <div className="dropdown-menu dropdown-menu-end" id="navbarItems">
        <NavBarItem
          title="Member"
          IconComponent={({ className }) => (
            <div className={`avatar ${className}`}>
              <span>{user.initials}</span>
            </div>
          )}
        />
        <div className="grouped">
          <NavBarItem
            title="Dashboard"
            active
            IconComponent={({ className }) => (
              <HoverIcon
                className={className}
                active
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/HoverIcon"
              >
                <path
                  d="M23.25 12.8535V12.8536V22.1295C23.25 22.5563 23.0784 22.9675 22.77 23.2721C22.4613 23.577 22.0406 23.75 21.6 23.75H2.4C1.95942 23.75 1.53873 23.577 1.22999 23.2721C0.921558 22.9675 0.75 22.5563 0.75 22.1295L0.75 12.8536L0.75 12.8535C0.749942 12.3116 0.861881 11.7752 1.07923 11.2769C1.2966 10.7786 1.61495 10.3288 2.01529 9.95521L2.01538 9.95513L10.863 1.69622L10.8631 1.69613C11.1689 1.41055 11.5756 1.25 12 1.25C12.4244 1.25 12.8311 1.41055 13.1369 1.69613L13.137 1.69622L21.9846 9.95513L21.9847 9.95521C22.3851 10.3288 22.7034 10.7786 22.9208 11.2769C23.1381 11.7752 23.2501 12.3116 23.25 12.8535Z"
                  stroke="var(--color)"
                  strokeWidth="1.5"
                />
              </HoverIcon>
            )}
          />
          <NavBarItem
            title="History"
            IconComponent={({ className }) => (
              <HoverIcon
                className={className}
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/HoverIcon"
              >
                <g clipPath="url(#clip0_1749_91040)">
                  <path
                    d="M16.0066 3.78955H18.8684C19.4756 3.78955 20.058 4.03076 20.4873 4.46012C20.9167 4.88948 21.1579 5.47182 21.1579 6.07902V20.9606C21.1579 21.5678 20.9167 22.1501 20.4873 22.5795C20.058 23.0089 19.4756 23.2501 18.8684 23.2501H5.13158C4.52437 23.2501 3.94203 23.0089 3.51267 22.5795C3.08331 22.1501 2.8421 21.5678 2.8421 20.9606V6.07902C2.8421 5.47182 3.08331 4.88948 3.51267 4.46012C3.94203 4.03076 4.52437 3.78955 5.13158 3.78955H7.99342"
                    stroke="var(--color)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.13193 3.23428C8.25574 2.73897 8.54155 2.29926 8.94393 1.98503C9.34631 1.6708 9.84218 1.50008 10.3527 1.5H13.6461C14.1567 1.50008 14.6525 1.6708 15.0549 1.98503C15.4573 2.29926 15.7431 2.73897 15.8669 3.23428L16.5789 6.07895H7.42105L8.13193 3.23428Z"
                    stroke="var(--color)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.56573 17.5264H15.4342"
                    stroke="var(--color)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M8.56573 12.5H15.4342"
                    stroke="var(--color)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1749_91040">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </HoverIcon>
            )}
          />
          <NavBarItem
            title="Add a test"
            IconComponent={({ className }) => (
              <svg
                className={className}
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1749_91042)">
                  <circle cx="23" cy="23" r="22.5" fill="#2862FA" />
                  <path
                    d="M23 32.2643C22.3094 32.2643 21.7496 31.7045 21.7496 31.0139V14.9853C21.7496 14.2947 22.3094 13.7349 23 13.7349C23.6906 13.7349 24.2504 14.2947 24.2504 14.9853V31.0139C24.2504 31.7045 23.6906 32.2643 23 32.2643ZM14.9794 24.2436C14.2923 24.2436 13.7353 23.6867 13.7353 22.9996C13.7353 22.3125 14.2923 21.7555 14.9794 21.7555H31.0207C31.7077 21.7555 32.2647 22.3125 32.2647 22.9996C32.2647 23.6867 31.7077 24.2436 31.0207 24.2436H14.9794Z"
                    fill="#F8F8FC"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1749_91042">
                    <rect
                      width="45"
                      height="45"
                      fill="white"
                      transform="translate(0.5 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            )}
          />
          <NavBarItem
            title="Help"
            IconComponent={({ className }) => (
              <HoverIcon
                className={className}
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/HoverIcon"
              >
                <g clipPath="url(#clip0_1749_91045)">
                  <circle
                    cx="12"
                    cy="12.5"
                    r="11.25"
                    stroke="var(--color)"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M10.4372 14.7551C10.4372 14.3435 10.4868 13.9848 10.586 13.6791C10.6977 13.3616 10.8713 13.0617 11.107 12.7795C11.355 12.4973 11.6837 12.2092 12.093 11.9152C12.5147 11.6095 12.8434 11.3449 13.0791 11.1214C13.3271 10.898 13.507 10.6805 13.6186 10.4688C13.7302 10.2454 13.786 9.99254 13.786 9.71031C13.786 9.26346 13.6186 8.92243 13.2837 8.68725C12.9612 8.45206 12.4961 8.33446 11.8884 8.33446C11.3426 8.33446 10.8217 8.4109 10.3256 8.56377C9.82946 8.70488 9.33333 8.89891 8.83721 9.14586L8 7.48779C8.57054 7.20556 9.1907 6.97038 9.86047 6.78223C10.5302 6.59408 11.2682 6.5 12.0744 6.5C13.3147 6.5 14.276 6.78811 14.9581 7.36432C15.6527 7.94052 16 8.68725 16 9.60448C16 10.1101 15.9132 10.5452 15.7395 10.9098C15.5783 11.2626 15.3364 11.5918 15.014 11.8976C14.6915 12.2033 14.2946 12.5267 13.8233 12.8677C13.4388 13.1499 13.1411 13.391 12.9302 13.5909C12.7318 13.7908 12.5953 13.9907 12.5209 14.1906C12.4589 14.3788 12.4279 14.614 12.4279 14.8962V15.3372H10.4372V14.7551ZM10.0837 18.1418C10.0837 17.6361 10.2202 17.2834 10.493 17.0834C10.7783 16.8835 11.1194 16.7836 11.5163 16.7836C11.9008 16.7836 12.2295 16.8835 12.5023 17.0834C12.7876 17.2834 12.9302 17.6361 12.9302 18.1418C12.9302 18.6239 12.7876 18.9708 12.5023 19.1825C12.2295 19.3942 11.9008 19.5 11.5163 19.5C11.1194 19.5 10.7783 19.3942 10.493 19.1825C10.2202 18.9708 10.0837 18.6239 10.0837 18.1418Z"
                    fill="var(--color)"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1749_91045">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </HoverIcon>
            )}
          />
          <NavBarItem
            title="Settings"
            IconComponent={({ className }) => (
              <HoverIcon
                className={className}
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/HoverIcon"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M22.4169 15.4881L23.9954 16.4543L23.9923 16.4594L22.3981 15.5191C22.4074 15.5035 22.4074 15.5035 22.4169 15.4881ZM24 16.4464C23.9938 16.4569 23.9938 16.4569 23.9875 16.4671L23.3588 16.0753L24 16.4464ZM19.2883 14.3832L19.4263 13.4153C19.4744 13.0784 19.4981 12.7752 19.4981 12.5C19.4981 12.2255 19.4747 11.9225 19.4249 11.5579L19.2937 10.5959L19.7281 10.2704L20.0753 10.0102L21.9009 8.64271L20.3907 6.14688L17.2769 7.34448L16.5315 6.79016C16.0038 6.39783 15.4413 6.0832 14.8268 5.83728L13.934 5.47997L13.8568 4.95494L13.7952 4.53591L13.4739 2.34615H10.3424L9.88052 5.48786L8.99918 5.84898C8.36538 6.10866 7.78645 6.43176 7.28176 6.80704L6.53629 7.36136L6.05894 7.17776L5.66727 7.02712L3.42267 6.16366L1.91253 8.65928L4.52496 10.6168L4.38692 11.5847C4.33886 11.9216 4.31514 12.2248 4.31514 12.5C4.31514 12.7745 4.33855 13.0775 4.3883 13.4421L4.51955 14.4041L4.08517 14.7296L3.73795 14.9898L1.91243 16.3575L3.42252 18.8531L6.53629 17.6555L7.28176 18.2098C7.80939 18.6022 8.37189 18.9168 8.98638 19.1627L9.8792 19.52L9.95638 20.0451L10.018 20.4641L10.3393 22.6538H13.4709L13.9327 19.5121L14.814 19.151C15.4478 18.8913 16.0268 18.5682 16.5315 18.193L17.2769 17.6386L17.7543 17.8222L18.146 17.9729L20.3906 18.8363L21.9008 16.3408L19.2883 14.3832ZM23.1478 14.9654C23.8312 15.4775 24.0151 16.4217 23.5735 17.1514L21.8967 19.9224C21.4787 20.6131 20.6235 20.9049 19.8685 20.6144L17.5641 19.728C16.9771 20.1548 16.3207 20.5213 15.6129 20.8193L15.2806 23.0793C15.1607 23.8952 14.4584 24.5 13.631 24.5H10.1791C9.35151 24.5 8.64915 23.895 8.5294 23.0789L8.20046 20.8371C7.50293 20.5493 6.856 20.187 6.24911 19.7449L3.94449 20.6312C3.18949 20.9216 2.33426 20.6298 1.91637 19.9391L0.239618 17.168C-0.201922 16.4383 -0.0179547 15.494 0.665505 14.982L2.5379 13.5792C2.48746 13.1833 2.46259 12.8331 2.46259 12.5C2.46259 12.166 2.48779 11.8139 2.53738 11.4373L0.66551 10.0347C-0.0178828 9.52259 -0.201795 8.57833 0.239743 7.84866L1.91654 5.07761C2.33447 4.38696 3.18974 4.09513 3.94474 4.38557L6.24916 5.27204C6.83613 4.84521 7.49251 4.47867 8.20036 4.1807L8.53258 1.9207C8.65252 1.10479 9.35479 0.5 10.1823 0.5H13.6341C14.4617 0.5 15.1641 1.10503 15.2838 1.92114L15.6128 4.16294C16.3103 4.45071 16.9572 4.81296 17.5641 5.25515L19.8687 4.36876C20.6237 4.07838 21.479 4.37023 21.8969 5.06087L23.5737 7.83213C24.0153 8.5619 23.8313 9.50626 23.1477 10.0183L21.2753 11.4209C21.3258 11.8168 21.3506 12.1669 21.3506 12.5C21.3506 12.834 21.3254 13.1861 21.2758 13.5627L23.1478 14.9654ZM11.907 16.3769C9.73858 16.3769 7.97563 14.644 7.97563 12.5C7.97563 10.356 9.73858 8.62308 11.907 8.62308C14.0754 8.62308 15.8383 10.356 15.8383 12.5C15.8383 14.644 14.0754 16.3769 11.907 16.3769ZM11.907 14.5308C13.0579 14.5308 13.9858 13.6187 13.9858 12.5C13.9858 11.3813 13.0579 10.4692 11.907 10.4692C10.7561 10.4692 9.82817 11.3813 9.82817 12.5C9.82817 13.6187 10.7561 14.5308 11.907 14.5308Z"
                  fill="var(--color)"
                />
              </HoverIcon>
            )}
          />
        </div>
        <NavBarItem
          title="Log out"
          IconComponent={({ className }) => (
            <HoverIcon
              className={className}
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/HoverIcon"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.7148 10.625L15.4102 12.9102C15.293 13.0404 15.2344 13.1901 15.2344 13.3594C15.2344 13.5286 15.293 13.6784 15.4102 13.8086C15.4753 13.8607 15.5469 13.903 15.625 13.9355C15.7031 13.9681 15.7812 13.9844 15.8594 13.9844C15.9375 13.9844 16.0156 13.9681 16.0938 13.9355C16.1719 13.903 16.2435 13.8607 16.3086 13.8086L20 10.0195L16.3086 6.23047C16.1784 6.10026 16.0286 6.03516 15.8594 6.03516C15.6901 6.03516 15.5404 6.10026 15.4102 6.23047C15.293 6.34766 15.2344 6.49414 15.2344 6.66992C15.2344 6.8457 15.293 6.99219 15.4102 7.10938L17.6758 9.375H6.89453C6.71224 9.375 6.5625 9.43359 6.44531 9.55078C6.32812 9.66797 6.26953 9.81771 6.26953 10C6.26953 10.1693 6.32812 10.3158 6.44531 10.4395C6.5625 10.5632 6.71224 10.625 6.89453 10.625H17.7148ZM1.25 0C0.911457 0 0.61849 0.120442 0.371094 0.361328C0.123697 0.602215 0 0.898436 0 1.25V18.75C0 19.1016 0.123697 19.3978 0.371094 19.6387C0.61849 19.8796 0.911457 20 1.25 20H11.875C12.2266 20 12.5228 19.8796 12.7637 19.6387C13.0046 19.3978 13.125 19.1016 13.125 18.75V13.1055H11.875V17.9883C11.875 18.1966 11.8001 18.3757 11.6504 18.5254C11.5007 18.6751 11.3216 18.75 11.1133 18.75H2.01172C1.80338 18.75 1.62761 18.6751 1.48438 18.5254C1.34114 18.3757 1.26953 18.1966 1.26953 17.9883L1.28906 2.01172C1.28906 1.80338 1.36068 1.62435 1.50391 1.47461C1.64714 1.32487 1.82292 1.25 2.03125 1.25H11.1133C11.3216 1.25 11.5007 1.32487 11.6504 1.47461C11.8001 1.62435 11.875 1.80338 11.875 2.01172V6.875H13.125V1.25C13.125 0.898436 13.0046 0.602215 12.7637 0.361328C12.5228 0.120442 12.2266 0 11.875 0H1.25Z"
                fill="var(--color)"
              />
            </HoverIcon>
          )}
        />
      </div>
    </div>
  </nav>
);

export default NavBar;
